import React from "react";
import {
  Table,
  TableRow,
  TableCell,
  TableHeader,
} from "carbon-react/lib/components/table";
import Help from "carbon-react/lib/components/help";
import Spinner from "carbon-react/lib/components/loader";
import SimpleTablePager from "../../../common/simpleTablePager/SimpleTablePager";
import { getEventFromEventCode } from "../../../../utils/auth0EventHelper";
import TableHeaderWithSortIndicator, {
  sortOrder,
} from "../../../common/tableHeaderWithSortIndicator/TableHeaderWithSortIndicator";
import { useLocalization } from "../../../../contexts/localization/Localization";

const UserLogsTable = ({ logsResultSet, loading, onChangePage }) => {
  const userLogs = logsResultSet.logs || [];
  const { getLocalizedDateStringFromUtcValue } = useLocalization();

  const tableRows = userLogs.map((log, key) => {
    const event = getEventFromEventCode(log.type) || {
      event: log.type,
    };

    return (
      <TableRow id={`user-log-table-row-${key}`} key={log.logId}>
        <TableCell id={`user-log-table-cell-date-${key}`}>
          {getLocalizedDateStringFromUtcValue(log.date)}
        </TableCell>
        <TableCell id={`user-log-table-cell-type-${key}`}>
          {event.event}
          {event.eventDescription && (
            <Help tooltipAlign="center" tooltipPosition="top" type="help">
              {event.eventDescription}
            </Help>
          )}
        </TableCell>
        <TableCell id={`user-log-table-cell-application-${key}`}>
          {log.clientName}
        </TableCell>
        <TableCell id={`user-log-table-cell-user-name-${key}`}>
          {log.userName}
        </TableCell>
      </TableRow>
    );
  });

  const tableHeader = (
    <TableRow id="user-log-table-header">
      <TableHeaderWithSortIndicator
        id="user-log-table-header-date"
        sortOrder={sortOrder.desc}
      >
        Date
      </TableHeaderWithSortIndicator>
      <TableHeader id="user-log-table-header-type">Type</TableHeader>
      <TableHeader id="user-log-table-header-application">
        Application
      </TableHeader>
      <TableHeader id="user-log-table-header-user-name">User name</TableHeader>
    </TableRow>
  );

  const onRequestPreviousPage = async () => {
    await onRequestPage(logsResultSet.currentPage - 1);
  };

  const onRequestNextPage = async () => {
    await onRequestPage(logsResultSet.currentPage + 1);
  };

  const onRequestPage = async (pageNumber) => {
    await onChangePage({
      skip: (pageNumber - 1) * logsResultSet.pageSize,
      pageSize: logsResultSet.pageSize,
    });
  };

  const gridSpinner = (
    <TableRow
      key="__loading__"
      selectable={false}
      highlightable={false}
      hideMultiSelect
    >
      <TableCell colSpan="100" align="center">
        <Spinner size="small" />
      </TableCell>
    </TableRow>
  );

  return (
    <>
      <Table isZebra thead={tableHeader} shrink>
        {loading === true ? gridSpinner : tableRows}
      </Table>
      <SimpleTablePager
        appearBusy={loading}
        pageNo={logsResultSet.currentPage}
        lastPage={logsResultSet.lastPage}
        onPagePrev={onRequestPreviousPage}
        onPageNext={onRequestNextPage}
      />
    </>
  );
};

export default UserLogsTable;
